import React, { memo } from "react";
import ListCard from "./ListCard";
import Banner from "./Banner";

const ListView = ({ top, middle, bottom, promo1, promo2, vendor }) => {
  return (
    <div className="w-full box-border">
      {top?.map((collection, index) => (
        <ListCard key={index} collection={{ ...collection, vendor }} />
      ))}
      <div className="w-full my-5 border-inherit">
        <Banner
          title={promo1.title}
          description={promo1.description.description}
          buttonText={promo1?.buttonText}
          buttonLink={promo1?.buttonLink}
          bgImage={promo1.backgroundImage}
          paddingBottom="40%"
        />
      </div>
      {middle?.map((collection, index) => (
        <ListCard key={index} collection={{ ...collection, vendor }} />
      ))}
      <Banner
        title={promo2.title}
        description={promo2.description.description}
        buttonText={promo2?.buttonText}
        buttonLink={promo2?.buttonLink}
        bgImage={promo2.backgroundImage}
        paddingBottom={{ md: "40%", lg: "25%" }}
        objectPosition="top"
      />
      {bottom?.map((collection, index) => (
        <ListCard key={index} collection={{ ...collection, vendor }} />
      ))}
    </div>
  );
};

export default memo(ListView);
